import { createSlice } from "@reduxjs/toolkit";
import { AppState } from "../../components/models/app";

const initialState : AppState = {
    openAuthDialog: false,
};

const appSlice = createSlice({
    name: "app",
    initialState,
    reducers: {
        setOpenAuthDialog: (state, action) => {
            state.openAuthDialog = action.payload;
        },
    },
});

export const { setOpenAuthDialog } = appSlice.actions;
export default appSlice.reducer;

